import { Heading } from '@chakra-ui/react'

const MediumHeading = ({ children }: { children: React.ReactNode }) => {
  return (
    <Heading textAlign="left" size="md" mb={4}>
      {children}
    </Heading>
  )
}

export default MediumHeading
